export default __webpack_public_path__ + "static/media/img_letters.0a8f1ac1.svg";